<template>
  <div id="app">
    <img src="./assets/shishito.jpg">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      title: 'Title',
      msg: 'Shishito'
    }
  },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.name
      }
    },
meta:  function () {
        return [
          { name: 'application-name', content: this.params.app },
          { name: 'description', content: this.params.description },
          { name: 'twitter:title', content: this.params.title },
          { n: 'twitter:description', c: this.params.description},
          { p: 'og:image', c: this.params.image },
        ]
      }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// App.vue?db07e958